// extracted by mini-css-extract-plugin
export var founder = "style-module--founder--90489";
export var info = "style-module--info--d4f6b";
export var item = "style-module--item--09205";
export var nya = "style-module--nya--e9c20";
export var zan = "style-module--zan--a8add";